import { Injectable } from '@angular/core';

import { AuthService } from 'core';

@Injectable({
  providedIn: 'root',
})
export class LoginStateService {
  get isLoggedIn(): boolean {
    return this.authService.loggedIn;
  }

  public loginTarget?: Array<string>;

  constructor(private readonly authService: AuthService) {}
}
